import React from "react";

interface DemoExpiredModalProps {
  show: boolean;
  isNXXGCrossAccount: boolean;
  onExit: () => void;
}

const DemoExpiredModal: React.FC<DemoExpiredModalProps> = ({
  show,
  isNXXGCrossAccount,
  onExit,
}) => {
  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">Demo period expired</h3>
          </div>
          <div className="modal-body">
            <div className="col-md-12">
              <h5>
                Your demo of TrustCall&trade; Monitor has expired. Would you like to add TrustCall&trade; to your account? You will be charged for your use on your next invoice.
                {" "}
                {isNXXGCrossAccount ? (
                  <>Please contact <a href="mailto:Compliance@nexxagroup.com">Compliance@nexxagroup.com</a> to activate your services.</>
                ) : (
                  <>Please contact <a href="mailto:support@dnc.com">support@dnc.com</a> to add TrustCall to your account.</>
                )}
                <br /><br />
              </h5>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onExit}>
                Exit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoExpiredModal;
